/**
 * Camera2D parser: the Node2D transform and the framing properties. Defaults
 * follow Godot: zoom (1,1), anchor_mode DRAG_CENTER (1), enabled true.
 */
import { parseNode2D } from '../../base/node2d/parser';
import { boolOr, intOr, vec2Or } from '../../../parser/valueParsers';
import { boolSlotValue } from '../../../godot/variant/variantBool.js';
import { Camera2DAnchorMode } from '../../../godot/scene/camera2d';
export function parseCamera2D(heading, properties) {
    const base = parseNode2D(heading, properties);
    return {
        ...base,
        zoom: vec2Or(properties.zoom, { x: 1, y: 1 }, 'Camera2D'),
        offset: vec2Or(properties.offset, { x: 0, y: 0 }, 'Camera2D'),
        anchor_mode: intOr(properties.anchor_mode, Camera2DAnchorMode.DRAG_CENTER),
        // class_camera2d.html: limits default to +/-10000000, limit_enabled true.
        limitLeft: intOr(properties.limit_left, -10000000),
        limitTop: intOr(properties.limit_top, -10000000),
        limitRight: intOr(properties.limit_right, 10000000),
        limitBottom: intOr(properties.limit_bottom, 10000000),
        limitEnabled: boolOr(properties.limit_enabled, true),
        enabled: properties.enabled === undefined ? true : boolSlotValue(properties.enabled) !== false,
    };
}
//# sourceMappingURL=parser.js.map